import { useEffect, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchAgentData } from '../../agent/store/agent.reducer'
import { selectAgentId } from '../../agent/store/agent.selectors'
import AuthService from '../services/auth.service'
import { setIsAuthenticated, authInit } from '../store/auth.reducer'

interface WindowWithCypress extends Window {
  Cypress?: any
}

export default function useAuth(service: AuthService) {
  const dispatch = useDispatch()
  const agentId = useSelector(selectAgentId)
  const [isAuth, setAuth] = useState(false)
  const setAuthentication = useCallback(
    (e) => {
      setAuth(e)
      if (e) {
        return dispatch(fetchAgentData())
      }
      const windowCypress: WindowWithCypress = window
      const isAuthenticated = !!windowCypress.Cypress
      return dispatch(setIsAuthenticated(isAuthenticated))
    },
    [dispatch, setAuth],
  )
  useEffect(() => {
    dispatch(authInit())
    const subs = service.isAuthenticated().subscribe(setAuthentication)
    return () => {
      subs.unsubscribe()
    }
  }, [dispatch, service, setAuthentication])

  useEffect(() => {
    if (isAuth && agentId) {
      dispatch(setIsAuthenticated(true))
    }
  }, [isAuth, agentId])
}
